import { useState } from "react";
import { Flame, Menu, X, Phone } from "lucide-react";
import { BUSINESS } from "@/lib/config";

const links = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Get Quote", href: "#calculator" },
  { label: "Book", href: "#book" },
  { label: "Service Area", href: "#service-area" },
  { label: "Reviews", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="navbar"
      className="sticky top-0 z-40 w-full bg-white border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-3"
          data-testid="navbar-logo"
        >
          <img
            src={BUSINESS.logoUrl}
            alt={BUSINESS.name}
            className="h-12 w-12 object-cover border border-slate-200"
          />
          <div className="leading-tight">
            <div className="font-display font-black tracking-tight text-lg">
              BID DVC
            </div>
            <div className="text-[10px] tracking-[0.25em] uppercase text-slate-500 font-bold">
              Dryer Vent Cleaning · St. Augustine
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-semibold tracking-wide text-slate-700 hover:text-[#002FA7] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={`tel:${BUSINESS.phoneRaw}`}
            className="hidden lg:flex items-center gap-2 text-sm font-semibold text-slate-700"
            data-testid="navbar-phone"
          >
            <Phone size={16} />
            {BUSINESS.phone}
          </a>
          <a
            href={`tel:${BUSINESS.phoneRaw}`}
            className="bid-btn-danger"
            data-testid="navbar-book-now"
          >
            <Phone size={14} />
            Call Now
          </a>
        </div>

        <button
          aria-label="menu"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden p-2 border-2 border-slate-900"
          data-testid="navbar-mobile-toggle"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-semibold text-slate-800"
              >
                {l.label}
              </a>
            ))}
            <a
              href={`tel:${BUSINESS.phoneRaw}`}
              className="bid-btn-danger justify-center"
              data-testid="navbar-mobile-book-now"
            >
              <Phone size={14} />
              Call {BUSINESS.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
